import { Organization } from "../types/Organization";

export const PUSH_ORGANIZATION = "PUSH_ORGANIZATION";
export const pushOrganization = (organization: Organization) => {
  return {
    type: PUSH_ORGANIZATION,
    organization,
  };
};
